"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regeneratorRuntime = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _createSuper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DestroyableNoOpDeviceController = void 0;

var NoOpMediaStreamBroker_1 = require("../mediastreambroker/NoOpMediaStreamBroker");

var NoOpDeviceController = /*#__PURE__*/function (_NoOpMediaStreamBroke) {
  _inherits(NoOpDeviceController, _NoOpMediaStreamBroke);

  var _super = _createSuper(NoOpDeviceController);

  function NoOpDeviceController(_options) {
    _classCallCheck(this, NoOpDeviceController);

    return _super.call(this);
  }

  _createClass(NoOpDeviceController, [{
    key: "listAudioInputDevices",
    value: function listAudioInputDevices() {
      return Promise.resolve([]);
    }
  }, {
    key: "listVideoInputDevices",
    value: function listVideoInputDevices() {
      return Promise.resolve([]);
    }
  }, {
    key: "listAudioOutputDevices",
    value: function listAudioOutputDevices() {
      return Promise.resolve([]);
    }
  }, {
    key: "chooseAudioInputDevice",
    value: function chooseAudioInputDevice(_device) {
      return Promise.reject();
    }
  }, {
    key: "chooseVideoInputDevice",
    value: function chooseVideoInputDevice(_device) {
      return Promise.reject();
    }
  }, {
    key: "chooseAudioOutputDevice",
    value: function chooseAudioOutputDevice(_deviceId) {
      return Promise.reject();
    }
  }, {
    key: "addDeviceChangeObserver",
    value: function addDeviceChangeObserver(_observer) {}
  }, {
    key: "removeDeviceChangeObserver",
    value: function removeDeviceChangeObserver(_observer) {}
  }, {
    key: "createAnalyserNodeForAudioInput",
    value: function createAnalyserNodeForAudioInput() {
      return null;
    }
  }, {
    key: "startVideoPreviewForVideoInput",
    value: function startVideoPreviewForVideoInput(_element) {}
  }, {
    key: "stopVideoPreviewForVideoInput",
    value: function stopVideoPreviewForVideoInput(_element) {}
  }, {
    key: "setDeviceLabelTrigger",
    value: function setDeviceLabelTrigger(_trigger) {}
  }, {
    key: "mixIntoAudioInput",
    value: function mixIntoAudioInput(_stream) {
      return null;
    }
  }, {
    key: "chooseVideoInputQuality",
    value: function chooseVideoInputQuality(_width, _height, _frameRate, _maxBandwidthKbps) {}
  }, {
    key: "getVideoInputQualitySettings",
    value: function getVideoInputQualitySettings() {
      return null;
    }
  }]);

  return NoOpDeviceController;
}(NoOpMediaStreamBroker_1.default);

exports.default = NoOpDeviceController;

var DestroyableNoOpDeviceController = /*#__PURE__*/function (_NoOpDeviceController) {
  _inherits(DestroyableNoOpDeviceController, _NoOpDeviceController);

  var _super2 = _createSuper(DestroyableNoOpDeviceController);

  function DestroyableNoOpDeviceController() {
    var _this;

    _classCallCheck(this, DestroyableNoOpDeviceController);

    _this = _super2.apply(this, arguments);
    _this.destroyed = false;
    return _this;
  }

  _createClass(DestroyableNoOpDeviceController, [{
    key: "destroy",
    value: function destroy() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.destroyed = true;

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return DestroyableNoOpDeviceController;
}(NoOpDeviceController);

exports.DestroyableNoOpDeviceController = DestroyableNoOpDeviceController;